import get from 'transmute/get';
import getIn from 'transmute/getIn';
export const getBotResponder = getIn(['sendFrom', '0']);
export const getChatHeadingConfig = getIn(['message', 'chatHeadingConfig']);
export const getColoring = get('coloring');
export const getConsentToCommunicateMessage = getIn(['message', 'customConsentToCommunicateMessage']);
export const getConsentToProcessMessage = getIn(['message', 'customConsentToProcessMessage']);
export const getLauncherType = getIn(['message', 'launcherType']);
export const getEnableAttachments = get('enableAttachments');
export const getEnableScreenCapture = get('enableScreencapture');
export const getEnableSdkCloseButton = get('enableSdkCloseButton');
export const getFont = get('widgetFont');
export const getGates = get('gates');
export const getGDPRConsentToProcessStatus = getIn(['gdprConsentOptions', 'consentToProcessStatus']);
export const getLanguage = get('language');
export const getMessage = get('message');
export const getRecommendedQuestionsForAgent = get('recommendedQuestionsForAgent');
export const getSendFrom = getIn(['sendFrom']);
export const getSearchableKnowledgeBaseIds = get('searchableKnowledgeBaseIds');
export const getSessionId = get('sessionId');
export const getShowPreviousConversations = get('showPreviousConversations');
export const getSpamProtectionMetadata = get('spamProtectionMetadata');
export const getSpotlightConfig = getIn(['message', 'spotlightConfig']);
export const getSuggestedPrompts = getIn(['message', 'spotlightConfig', 'suggestedPrompts']);
export const getTypicalResponseTime = get('typicalResponseTime');